import React from 'react';

const LoadingIntermediate = () => (
    <div className="progress">
        <div className="progress-bar-indeterminate" />
    </div>
);

export default LoadingIntermediate;


// WEBPACK FOOTER //
// ./src/components/indicators/loading-intermdiate.js